export enum Themes { Default = 'default', White = 'white', Blue = 'blue', Cactus = 'cactus' }


// WEBPACK FOOTER //
// ./src/app/views/presentations/themes.ts